import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/footer.css";
import "../css/footer.css";
import logo from "../image/logo.webp";
import { useNavigate } from "react-router-dom";
function Footer({ setShowModal }) {
  const [result, setResult] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    const dataObj = Object.fromEntries(formData.entries());
    dataObj.subject = "New Enquiry from Footer Section";

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataObj)
      });

      const data = await response.json();

      if (data.success) {
        navigate("/thank-you");
        event.target.reset();
      } else {
        console.log("Error", data);
        setResult("Something went wrong while submitting your enquiry. Please try again.");
      }
    } catch (error) {
      setResult("Something went wrong while submitting your enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="footer-premium position-relative pt-5" id="contact">
      {/* Newsletter / Contact Quick */}
      <div className="container position-relative z-1">
        <div className="cta-banner rounded-4 p-4 p-md-5 mb-5 shadow-lg d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="mb-4 mb-md-0 text-center text-md-start">
            <h3 className="fw-bold mb-2 text-white">Ready to Start Your Franchise?</h3>
            <p className="mb-0 text-white-50">Join our network of successful pharma professionals today.</p>
          </div>
          <div className="d-flex flex-column flex-sm-row gap-3">
            <button className="btn btn-light fw-bold px-4 py-3 rounded-pill text-dark" onClick={() => setShowModal(true)}>
              Get Consultant
            </button>
            <a href="tel:+917827552889" className="btn btn-outline-light fw-bold px-4 py-3 rounded-pill d-flex align-items-center justify-content-center gap-2">
              <i className="bi bi-telephone"></i> Call Us
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container pb-5">
        <div className="row g-5">
          {/* About */}
          <div className="col-lg-4 mb-4 text-center text-lg-start">
            <a className="d-inline-block mb-4" href="/">
              <img src={logo} width="180" alt="Logo" />
            </a>
            <p className="footer-about text-secondary mb-4 mx-auto mx-lg-0" style={{ lineHeight: "1.8", fontSize: "16px", maxWidth: "400px", color: "#151616 !important" }}>
              Join us in delivering DCGI-approved, innovation-driven formulations to markets that matter. We’re inviting ambitious partners to expand our legacy into new territories.
            </p>

            <div className="d-flex gap-3 justify-content-center justify-content-lg-start social-links">
              <Link to="https://www.facebook.com/people/ChemoBiological/61569662266911/?rdid=IHxEDEm2yaKUAxLG&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DTCqNyQ7g%2F" className="social-icon rounded-circle d-flex align-items-center justify-content-center">
                <i className="bi bi-facebook"></i>
              </Link>
              <Link to="https://www.instagram.com/chemobiological?igsh=NjZ5Y242dGcyazg5" className="social-icon rounded-circle d-flex align-items-center justify-content-center">
                <i className="bi bi-instagram"></i>
              </Link>
              <Link to="https://wa.me/917827552889" className="social-icon rounded-circle d-flex align-items-center justify-content-center">
                <i className="bi bi-whatsapp"></i>
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-4 mb-4 text-center text-lg-start">
            <h5 className="footer-title text-dark mb-4 position-relative d-inline-block d-lg-block">Quick Links</h5>
            <ul className="footer-list list-unstyled d-flex flex-column gap-3 align-items-center align-items-lg-start">
              {[
                { name: "About Us", id: "about" },
                { name: "Top Categories", id: "top" },
                { name: "Our Products", id: "product" },
                { name: "Our Testimonials", id: "certificate" },
                { name: "Our Clients", id: "test" },
                { name: "Contact Us", id: "contact" },
              ].map((link, index) => (
                <li key={index}>
                  <a
                    href={`#${link.id}`}
                    className="footer-link d-flex align-items-center gap-2 text-decoration-none"
                    onClick={(e) => {
                      e.preventDefault();
                      const section = document.getElementById(link.id);
                      if (section) section.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    <i className="bi bi-chevron-right text-orange small"></i> {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Contact Form */}
          <div className="col-lg-4 mb-4 text-center text-lg-start">
            <h5 className="footer-title text-dark mb-4 position-relative d-inline-block d-lg-block">Start Your Pharma Business Today</h5>

            <form onSubmit={onSubmit} className="mt-3">
              <div className="mb-3">
                <input type="text" name="name" className="form-control bg-white text-dark py-2 border shadow-sm" placeholder="Your Name*" required style={{ borderRadius: "8px", fontSize: "14px" }} />
              </div>
              <div className="mb-3">
                <input type="tel" name="phone" className="form-control bg-white text-dark py-2 border shadow-sm" placeholder="Phone Number*" pattern="[0-9]{10}" maxLength="10" minLength="10" title="Please enter a valid 10-digit phone number" required style={{ borderRadius: "8px", fontSize: "14px" }} />
              </div>
              <div className="mb-3">
                <input type="email" name="email" className="form-control bg-white text-dark py-2 border shadow-sm" placeholder="Email Address" style={{ borderRadius: "8px", fontSize: "14px" }} />
              </div>
              <div className="mb-3">
                <textarea name="message" className="form-control bg-white text-dark py-2 border shadow-sm" placeholder="Your Message*" rows="3" required style={{ borderRadius: "8px", fontSize: "14px" }}></textarea>
              </div>
              <button type="submit" disabled={isSubmitting} className="btn w-100 fw-bold py-2 text-white" style={{ backgroundColor: "#e86229", borderRadius: "8px", fontSize: "15px" }}>
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
              {result && <div className="text-center small mt-2 fw-bold text-danger">{result}</div>}
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bottom-bar py-4">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 text-secondary small">
          <div className="text-center text-md-start" style={{ fontSize: "15px" }}>
            Copyright © 2026 <strong className="text-dark">Chemo Biological</strong>. All Rights Reserved.
            Managed with Excellence by <a href="https://brandbanalo.com" className="text-orange text-decoration-none">Brandbanalo</a>
          </div>
          <div className="d-flex gap-4" >
            <Link to="/terms-and-conditions" className="footer-bottom-link text-decoration-none">Terms & Conditions</Link>
            <Link to="/privacy-policy" className="footer-bottom-link text-decoration-none">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
